import KunLoading102 from './src/index'

KunLoading102.install = function (Vue) {
	Vue.component(KunLoading102.name, KunLoading102);
}

export default KunLoading102;
